import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningIcon from '@mui/icons-material/Warning';

const LegendContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2.5),
  borderRadius: theme.spacing(1.5),
  backgroundColor: '#ffffff',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
  border: '1px solid #e2e8f0',
}));

const LegendTitle = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 600,
  color: '#475569',
  marginBottom: theme.spacing(2),
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
}));

const LegendItems = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
  },
}));

const LegendItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  minWidth: 120,
  [theme.breakpoints.down('sm')]: {
    minWidth: 'auto',
  },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 32,
  height: 32,
  borderRadius: theme.spacing(1),
  backgroundColor: '#f8fafc',
  '& .MuiSvgIcon-root': {
    fontSize: '1.125rem',
  },
}));

const LegendText = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 500,
  color: '#64748b',
}));

const StatusLegend: React.FC = () => {
  const statuses = [
    { 
      icon: <RadioButtonUncheckedIcon />, 
      label: '未開始', 
      color: '#94a3b8',
      bgColor: '#f1f5f9',
    },
    { 
      icon: <WatchLaterIcon />, 
      label: '進行中', 
      color: '#3b82f6',
      bgColor: '#dbeafe',
    },
    { 
      icon: <CheckCircleIcon />, 
      label: '已完成', 
      color: '#10b981',
      bgColor: '#d1fae5',
    },
    { 
      icon: <CancelIcon />, 
      label: '驗收失敗', 
      color: '#ef4444',
      bgColor: '#fee2e2',
    },
    { 
      icon: <WarningIcon />, 
      label: '已延遲', 
      color: '#f59e0b',
      bgColor: '#fef3c7',
    },
  ];

  return (
    <LegendContainer elevation={0}>
      <LegendTitle>任務狀態說明</LegendTitle>
      <LegendItems>
        {statuses.map((status) => (
          <LegendItem key={status.label}>
            <IconWrapper sx={{ backgroundColor: status.bgColor }}>
              {React.cloneElement(status.icon, { 
                sx: { color: status.color } 
              })}
            </IconWrapper>
            <LegendText>{status.label}</LegendText>
          </LegendItem>
        ))}
      </LegendItems>
    </LegendContainer>
  );
};

export default StatusLegend; 